// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checklist-item {
  margin-top: 50px;
}
.checklist-item__background {
  background: #f5f5f5;
  height: 230vh;
}
.checklist-item__card-profile-changes {
  margin: auto;
  padding: 20px;
  background-color: #ffffff;
  border: 1px solid #f3f5f6;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
.checklist-item__popup__icon {
  cursor: pointer;
}
.checklist-item__popup__accept {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  cursor: pointer;
  padding-top: 4px;
}
.checklist-item__popup__reject {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
  cursor: pointer;
  padding-top: 12px;
}
.checklist-item__head {
  background: #f5f5f5;
  margin-bottom: 30px;
}
.checklist-item__head__head {
  display: flex;
}
.checklist-item__head__head-text {
  padding-top: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
}
.checklist-item__head__head-badge {
  margin-left: 12px;
  margin-top: 5px;
}
.checklist-item__head__head-options {
  margin-left: auto;
  padding-top: 20px;
}
.checklist-item__head__subhead-text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  padding-top: 10px;
}
.checklist-item__body {
  padding-top: 30px;
}
.checklist-item__body__table {
  width: 100%;
}
.checklist-item__body__left {
  width: 50%;
}
.checklist-item__body__right {
  width: 50%;
  padding: 3%;
  border-left: 1px solid #e9e9e9;
}

.checklist-item-cards {
  width: 100%;
  background: #f5f5f5;
  padding-bottom: 25px;
}

.checklist-item-basic-info__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}
.checklist-item-basic-info__body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #333333;
}
.checklist-item-basic-info__row {
  display: flex;
  margin-top: 20px;
}
.checklist-item-basic-info__col1 {
  width: 30%;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #999999;
}
.checklist-item-basic-info__col1__line {
  padding-top: 6px;
}
.checklist-item-basic-info__col2 {
  width: 50%;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #505054;
}
.checklist-item-basic-info__badge {
  margin-right: 10px;
  margin-top: 20px;
  display: inline-block;
  background: #f2f2f2;
  border-radius: 50px;
  padding: 6px 12px 6px 12px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.checklist-item-basic-info__number {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #49ae9e;
}

.checklist-item-right__part2 {
  margin-top: 100px;
}
.checklist-item-right__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
}
.checklist-item-right__body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}

.checklist-item-setting__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}
.checklist-item-setting__body {
  padding-top: 10px;
}
.checklist-item-setting__table {
  width: 100%;
}
.checklist-item-setting__table__left {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #868686;
  padding-top: 20px;
}
.checklist-item-setting__table__right {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  text-align: right;
}

.checklist__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}
.checklist__list {
  margin-top: 30px;
}
.checklist__item {
  display: flex;
  gap: 10px;
  height: 56px;
  border-bottom: 1px solid #e9e9e9;
  align-items: center;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.checklist__item__item {
  flex: 1 1;
}
.checklist__item__item__text {
  margin-left: 10px;
}
.checklist__item__type {
  display: flex;
  margin-left: auto;
}
.checklist__item__type__text {
  margin-left: 6px;
}
.checklist__item__type__text-abnormal {
  margin-left: 6px;
  color: #bd1922;
}
.checklist__attachments {
  margin-top: 40px;
}
.checklist__attachments__head {
  display: flex;
}
.checklist__attachments__head-text {
  margin-bottom: 8px;
  margin-left: 6px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #999999;
}
.checklist__attachments__body {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
}
.checklist__attachments__images {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 auto;
}
.checklist__attachments__image {
  height: 140px;
  width: 140px;
  border-radius: 8px;
  flex: 0 0 90px;
  margin: 5px;
  cursor: pointer;
}
.checklist__memo {
  margin-top: 40px;
}
.checklist__memo__head {
  display: flex;
}
.checklist__memo__head-text {
  margin-left: 6px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #999999;
}
.checklist__memo__body {
  margin-top: 15px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #505054;
}
.checklist__checked-employee {
  margin-top: 40px;
}
.checklist__checked-employee__head {
  display: flex;
}
.checklist__checked-employee__head-text {
  margin-left: 6px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #999999;
}
.checklist__checked-employee__body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #505054;
}
.checklist__checked-employee__badge {
  margin-right: 10px;
  margin-top: 20px;
  display: inline-block;
  background: #f2f2f2;
  border-radius: 50px;
  padding: 6px 12px 6px 12px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  cursor: pointer;
}

@media (min-width: 700px) {
  .image-content {
    width: 500px;
  }
}
@media (min-width: 800px) {
  .image-content {
    width: 700px;
  }
}
@media (min-width: 1000px) {
  .image-content {
    width: 800px;
  }
}
@media (min-width: 1200px) {
  .image-content {
    width: 900px;
  }
}
@media (min-width: 1400px) {
  .image-content {
    width: 1100px;
  }
}
@media (min-width: 1600px) {
  .image-content {
    width: 1200px;
  }
}
@media (min-width: 1800px) {
  .image-content {
    width: 1400px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/checklist/checklist-item/checklist-item.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;AACI;EACI,mBAAA;EACA,aAAA;AACR;AAEI;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;AAAR;AAIQ;EACI,eAAA;AAFZ;AAKQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAHZ;AAMQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAJZ;AAQI;EACI,mBAAA;EACA,mBAAA;AANR;AAQQ;EACI,aAAA;AANZ;AASQ;EACI,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAPZ;AAUQ;EACI,iBAAA;EACA,eAAA;AARZ;AAWQ;EACI,iBAAA;EACA,iBAAA;AATZ;AAYQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAVZ;AAcI;EACI,iBAAA;AAZR;AAcQ;EACI,WAAA;AAZZ;AAeQ;EACI,UAAA;AAbZ;AAgBQ;EACI,UAAA;EACA,WAAA;EACA,8BAAA;AAdZ;;AAmBA;EACI,WAAA;EACA,mBAAA;EACA,oBAAA;AAhBJ;;AAoBI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjBR;AAoBI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlBR;AAqBI;EACI,aAAA;EACA,gBAAA;AAnBR;AAsBI;EACI,UAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArBR;AAuBQ;EACI,gBAAA;AArBZ;AAyBI;EACI,UAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxBR;AA2BI;EACI,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1BR;AA6BI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA3BR;;AAgCI;EACI,iBAAA;AA7BR;AAgCI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA9BR;AAiCI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA/BR;;AAoCI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjCR;AAoCI;EACI,iBAAA;AAlCR;AAqCI;EACI,WAAA;AAnCR;AAqCQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAnCZ;AAsCQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAEA,iBAAA;AArCZ;;AA2CI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxCR;AA2CI;EACI,gBAAA;AAzCR;AA4CI;EACI,aAAA;EACA,SAAA;EACA,YAAA;EACA,gCAAA;EACA,mBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA3CR;AA6CQ;EACI,SAAA;AA3CZ;AA4CY;EACI,iBAAA;AA1ChB;AA8CQ;EACI,aAAA;EACA,iBAAA;AA5CZ;AA8CY;EACI,gBAAA;AA5ChB;AA+CY;EACI,gBAAA;EACA,cAAA;AA7ChB;AAkDI;EACI,gBAAA;AAhDR;AAkDQ;EACI,aAAA;AAhDZ;AAmDQ;EACI,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjDZ;AAoDQ;EACI,aAAA;EACA,eAAA;EACA,gBAAA;AAlDZ;AAsDQ;EACI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AApDZ;AAuDQ;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EAEA,cAAA;EACA,WAAA;EACA,eAAA;AAtDZ;AA0DI;EACI,gBAAA;AAxDR;AA0DQ;EACI,aAAA;AAxDZ;AA2DQ;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAzDZ;AA4DQ;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1DZ;AA8DI;EACI,gBAAA;AA5DR;AA8DQ;EACI,aAAA;AA5DZ;AA+DQ;EACI,gBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7DZ;AAgEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA9DZ;AAiEQ;EACI,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAhEZ;;AAqEA;EACI;IACI,YAAA;EAlEN;AACF;AAoEA;EACI;IACI,YAAA;EAlEN;AACF;AAqEA;EACI;IACI,YAAA;EAnEN;AACF;AAsEA;EACI;IACI,YAAA;EApEN;AACF;AAuEA;EACI;IACI,aAAA;EArEN;AACF;AAwEA;EACI;IACI,aAAA;EAtEN;AACF;AAyEA;EACI;IACI,aAAA;EAvEN;AACF","sourcesContent":[".checklist-item {\n    margin-top: 50px;\n\n    &__background {\n        background: #f5f5f5;\n        height: 230vh;\n    }\n\n    &__card-profile-changes {\n        margin: auto;\n        padding: 20px;\n        background-color: #ffffff;\n        border: 1px solid #f3f5f6;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n    }\n\n    &__popup {\n        &__icon {\n            cursor: pointer;\n        }\n\n        &__accept {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #333333;\n            cursor: pointer;\n            padding-top: 4px;\n        }\n\n        &__reject {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 20px;\n            color: #333333;\n            cursor: pointer;\n            padding-top: 12px;\n        }\n    }\n\n    &__head {\n        background: #f5f5f5;\n        margin-bottom: 30px;\n\n        &__head {\n            display: flex;\n        }\n\n        &__head-text {\n            padding-top: 10px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n        }\n\n        &__head-badge {\n            margin-left: 12px;\n            margin-top: 5px;\n        }\n\n        &__head-options {\n            margin-left: auto;\n            padding-top: 20px;\n        }\n\n        &__subhead-text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n            padding-top: 10px;\n        }\n    }\n\n    &__body {\n        padding-top: 30px;\n\n        &__table {\n            width: 100%;\n        }\n\n        &__left {\n            width: 50%;\n        }\n\n        &__right {\n            width: 50%;\n            padding: 3%;\n            border-left: 1px solid #e9e9e9;\n        }\n    }\n}\n\n.checklist-item-cards {\n    width: 100%;\n    background: #f5f5f5;\n    padding-bottom: 25px;\n}\n\n.checklist-item-basic-info {\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n\n    &__body {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        color: #333333;\n    }\n\n    &__row {\n        display: flex;\n        margin-top: 20px;\n    }\n\n    &__col1 {\n        width: 30%;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 24px;\n        color: #999999;\n\n        &__line {\n            padding-top: 6px;\n        }\n    }\n\n    &__col2 {\n        width: 50%;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #505054;\n    }\n\n    &__badge {\n        margin-right: 10px;\n        margin-top: 20px;\n        display: inline-block;\n        background: #f2f2f2;\n        border-radius: 50px;\n        padding: 6px 12px 6px 12px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n    }\n\n    &__number {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        color: #49ae9e;\n    }\n}\n\n.checklist-item-right {\n    &__part2 {\n        margin-top: 100px;\n    }\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #666666;\n    }\n\n    &__body {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #999999;\n    }\n}\n\n.checklist-item-setting {\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n\n    &__body {\n        padding-top: 10px;\n    }\n\n    &__table {\n        width: 100%;\n\n        &__left {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 24px;\n            color: #868686;\n            padding-top: 20px;\n        }\n\n        &__right {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 24px;\n            color: #333333;\n\n            text-align: right;\n        }\n    }\n}\n\n.checklist {\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n\n    &__list {\n        margin-top: 30px;\n    }\n\n    &__item {\n        display: flex;\n        gap: 10px;\n        height: 56px;\n        border-bottom: 1px solid #e9e9e9;\n        align-items: center;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n\n        &__item {\n            flex: 1;\n            &__text {\n                margin-left: 10px;\n            }\n        }\n\n        &__type {\n            display: flex;\n            margin-left: auto;\n\n            &__text {\n                margin-left: 6px;\n            }\n\n            &__text-abnormal {\n                margin-left: 6px;\n                color: #bd1922;\n            }\n        }\n    }\n\n    &__attachments {\n        margin-top: 40px;\n\n        &__head {\n            display: flex;\n        }\n\n        &__head-text {\n            margin-bottom: 8px;\n            margin-left: 6px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #999999;\n        }\n\n        &__body {\n            display: flex;\n            flex-wrap: wrap;\n            list-style: none;\n            // margin: 0 auto;\n        }\n\n        &__images {\n            display: flex;\n            flex-wrap: wrap;\n            list-style: none;\n            margin: 0 auto;\n        }\n\n        &__image {\n            height: 140px;\n            width: 140px;\n            border-radius: 8px;\n\n            flex: 0 0 90px;\n            margin: 5px;\n            cursor: pointer;\n        }\n    }\n\n    &__memo {\n        margin-top: 40px;\n\n        &__head {\n            display: flex;\n        }\n\n        &__head-text {\n            margin-left: 6px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #999999;\n        }\n\n        &__body {\n            margin-top: 15px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 24px;\n            color: #505054;\n        }\n    }\n\n    &__checked-employee {\n        margin-top: 40px;\n\n        &__head {\n            display: flex;\n        }\n\n        &__head-text {\n            margin-left: 6px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #999999;\n        }\n\n        &__body {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 16px;\n            line-height: 24px;\n            color: #505054;\n        }\n\n        &__badge {\n            margin-right: 10px;\n            margin-top: 20px;\n            display: inline-block;\n            background: #f2f2f2;\n            border-radius: 50px;\n            padding: 6px 12px 6px 12px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n            cursor: pointer;\n        }\n    }\n}\n\n@media (min-width: 700px) {\n    .image-content {\n        width: 500px;\n    }\n}\n@media (min-width: 800px) {\n    .image-content {\n        width: 700px;\n    }\n}\n\n@media (min-width: 1000px) {\n    .image-content {\n        width: 800px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .image-content {\n        width: 900px;\n    }\n}\n\n@media (min-width: 1400px) {\n    .image-content {\n        width: 1100px;\n    }\n}\n\n@media (min-width: 1600px) {\n    .image-content {\n        width: 1200px;\n    }\n}\n\n@media (min-width: 1800px) {\n    .image-content {\n        width: 1400px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
